export default __webpack_public_path__ + "static/media/inbox.f0ce8a1b.svg";